import React from 'react';
export function BrandPartners() {
  const partners = ['GAF', 'Owens Corning', 'CertainTeed', 'James Hardie', 'Pella', 'Andersen'];
  return <section className="py-12 bg-gray-100 border-y border-gray-200" data-id="element-56">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-57">
        <p className="text-center font-heading font-bold text-sm text-brand-gray uppercase tracking-wider mb-8" data-id="element-58">
          Trusted Brand Partners & Premium Materials
        </p>
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-60 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-59">
          {partners.map((partner, index) => <div key={index} className="font-heading font-bold text-2xl text-brand-gray-dark" data-id="element-60">
              {partner}
            </div>)}
        </div>
      </div>
    </section>;
}